import IApprove from 'models/approve';
import { QrElectronicCode, QrHealthClaimsCode, QrNutritionClaimsCode } from 'models/product';
import isNil from 'lodash/isNil';

export interface IProductUpdateInput {
  adminStatus?: string;
  alcoholPercentage?: number;
  BNR?: string;
  // category: String
  // foodlaCategory: FoodlaCategoryInput
  classification?: string;
  descriptive_size?: string;
  descriptive_size_amount?: number;
  descriptive_size_amount_extra?: number[];
  // descriptive_size_unit: DescriptiveSizeUnit
  EAN?: string;
  EAN2?: string;
  // id: ID! TODO:
  images?: string[];
  ingredient_statement?: string;
  latitude?: number;
  location?: string;
  longitude?: number;

  energi_kj?: number;
  energi_kcal?: number;
  fett?: number;
  mattatFett?: number;
  enkelomattatFett?: number;
  flerromattatFett?: number;
  kolhydrat?: number;
  sockerarter?: number;
  polyoler?: number;
  starkelse?: number;
  fiber?: number;
  protein?: number;
  salt?: number;
  // nutritional_unit: NutritionalUnit
  gross_weight_num?: number;
  gross_height?: number;
  gross_width?: number;
  gross_depth?: number;

  vitaminA?: number;
  vitaminD?: number;
  vitaminE?: number;
  vitaminK?: number;
  vitaminC?: number;
  tiamin?: number;
  riboflavin?: number;
  niacin?: number;
  vitaminB6?: number;
  folsyra?: number;
  vitaminB12?: number;
  biotin?: number;
  pantotensyra?: number;
  kalium?: number;
  klorid?: number;
  kalcium?: number;
  fosfor?: number;
  magnesium?: number;
  jarn?: number;
  zink?: number;
  koppar?: number;
  mangan?: number;
  fluorid?: number;
  selen?: number;
  krom?: number;
  molybden?: number;
  jod?: number;

  place_of_item_activity?: string;
  additional_required_information?: string;
  quantity_in_stock?: number;
  inactive?: boolean;
  pricing?: string;
  // producer?: ProducerInput!
  short_text?: string;
  title?: string;
  trade_item_temperature_information?: string;
  unit?: string;
  video?: string;
  consumer_size_to_order_size_ratio?: number;
  // approve: [ApproveInput]
  // labels: [LabelInput]

  color?: string;
  non_food_ingredients?: string;
  material?: string;
  dimensions?: string;
  capacity?: string;
  package_size?: number;
  package_size_unit?: string;
  country_of_manufacturing?: number;
  brand?: string;
  brand_food?: string;

  min_temperature?: number;
  max_temperature?: number;
  search_terms?: string;
  imageUnderProcess?: boolean;
  ignoreEANLengthError?: boolean;

  price?: number;
  priceEAN?: string;
  issueActiveDate?: number;
  lastreturndate?: number;
  totalNumberIssues?: number;
  currentIssueNumber?: number;
  currentIssueYear?: number;
  isMagazine?: boolean;
  alternativeTitle?: string;

  // Basic Data
  basicDataMixCategory?: boolean;
  basicDataTradeItemVariableUnit?: boolean;
  basicDataTaxClassification?: number;
  basicDataPriceComparisonContentType?: string;
  basicDataAvailabilityDateFrom?: number;
  articleFirstOrderDate?: number;
  articleFirstDelivery?: number;
  basicDataCbuIndicator?: boolean;

  // Konsumentförpackning / Consumer pack
  consumerPackOrderableUnit?: boolean;
  consumerPackDespatchUnit?: boolean;
  consumerPackNetWeight?: number;

  // Butiksförpackning / Store pack
  storePackEANForStorePack?: string;
  storePackOrderableUnit?: boolean;
  storePackDespatchUnit?: boolean;
  storePackTradeItemMeasurementsLengthDepth?: number;
  storePackTradeItemMeasurementsWidth?: number;
  storePackTradeItemMeasurementsHeight?: number;
  storePackGrossWeight?: number;

  // Transportförpackning / Transport Pack
  transportEANForStorePack?: string;
  transportQtyOfBaseItem?: number;
  transportQtyOfNextLowerItem?: number;
  transportOrderableUnit?: boolean;
  transportDespatchUnit?: boolean;
  transportTradeItemMeasurementsLengthDepth?: number;
  transportTradeItemMeasurementsWidth?: number;
  transportTradeItemMeasurementsHeight?: number;
  transportGrossWeight?: number;
  transportMinTemperature?: number;
  transportMaxTemperature?: number;

  // Pall/Pallet Layer
  palletLayerEANForStorePack?: string;
  palletLayerQtyOfBaseItem?: number;
  palletLayerQtyOfNextLowerItem?: number;
  palletLayerOrderableUnit?: boolean;
  palletLayerDespatchUnit?: boolean;
  palletLayerTradeItemMeasurementsLengthDepth?: number;
  palletLayerTradeItemMeasurementsWidth?: number;
  palletLayerTradeItemMeasurementsHeight?: number;
  palletLayerGrossWeight?: number;

  // Pall/Pallet
  palletQtyOfStorePack?: number;
  palletEANForStorePack?: string;
  palletQtyOfBaseItem?: number;
  palletQtyOfNextLowerItem?: number;
  palletOrderableUnit?: boolean;
  palletDespatchUnit?: boolean;
  palletTradeItemMeasurementsLengthDepth?: number;
  palletTradeItemMeasurementsWidth?: number;
  palletTradeItemMeasurementsHeight?: number;
  palletGrossWeight?: number;
  lavQuantity?: number;

  // Price
  priceListPriceCurrency?: string;
  priceListPrice?: number;
  priceRecommendedConsumerPrice?: number;

  // Purchasing Data
  purchasingDataSupplierArticleNo?: string;
  purchasingDataIncoterm?: string;
  purchasingDataPickupLocation?: string;

  // Quality review
  qrLabelingSwedish?: boolean;
  qrMedicalClaims?: boolean;
  qrMarketingClaimsCosmetic?: boolean;
  qrEfsaUlValues?: boolean;
  qrNutritionClaims?: boolean;
  qrNutritionClaimsCode?: QrNutritionClaimsCode | null;
  qrHealthClaims?: boolean;
  qrHealthClaimsCode?: QrHealthClaimsCode | null;
  qrFoodLabeling?: boolean;
  qrMisleadingSalesTerms?: boolean;
  qrFoodHygiene?: boolean;
  qrClassificationLabelingPackaging?: boolean;
  qrElectronic?: boolean;
  qrElectronicCode?: QrElectronicCode | null;
  qrAdditivesInFeed?: boolean;
  qrFeedLabeling?: boolean;
  qrRelevantFeedCertifications?: boolean;

  // New string fields
  shortSalesDescription?: string;
  animalFoodIngredients?: string;
  eggPackerApprovalNumber?: string;
  dosageAndUsageInstructions?: string;
  preparationInstructions?: string;
  responsibleLabelingApprovalNumber?: string;
  feedAdditives?: string;
  analyticalConstituentsFeed?: string;
  feedingInstructions?: string;
  animalAgeGroup?: string;
  CMRSubstances?: string;
  informationHazardousSubstances?: string;
  specifyCEStandards?: string;
  explanationNoUDI?: string;
  regulatedSubstance?: string;

  // New boolean fields
  cmrSubstance?: boolean;
  reachSubstance?: boolean;
  bestBeforeDate?: boolean;
  childrenUnder16?: boolean;
  complianceEg12232009?: boolean;
  complianceReach19072006?: boolean;
  reachSubstancesAnnex19072006?: boolean;
  hazardousSubstancesOver1?: boolean;
  complianceProductSafety2004451?: boolean;
  ceMarking?: boolean;
  complianceMedicalTechProducts?: boolean;
  complianceHaccp?: boolean;
  plasticTrayPackaging?: boolean;
  compliancePpwrPackaging?: boolean;
  checkUniqueIdentification?: boolean;

  // New single select fields
  // fishProductionMethod?: FishProductionMethodEnum;
  // fishCatchMethod?: FishCatchMethodEnum;
  // catchArea?: CatchAreaEnum;
  // eggWeightClass?: EggWeightClassEnum;
  // recyclingType?: RecyclingTypeEnum;
  // signalWords?: SignalWordsEnum;
  // preparedForm?: PreparedFormEnum;
  // categoryWeightloss?: CategoryWeightlossEnum;
  // complianceBiocid?: ComplianceBiocidEnum;
  // complianceBiocidalTreated?: ComplianceBiocidalTreatedEnum;
  // confirmGuidanceSwedishElectronics?: ConfirmGuidanceSwedishElectronicsEnum;
  // complianceToyDirective?: ComplianceToyDirectiveEnum;
  // complianceMetalsSkinContact?: ComplianceMetalsSkinContactEnum;
  // approvalDietFeed?: ApprovalDietFeedEnum;
  // complianceSunscreenRegulation?: ComplianceSunscreenRegulationEnum;
  // sunProtectionFactor?: SunProtectionFactorEnum;

  // New multiple select fields
  // additionalCharacteristics: [AdditionalCharacteristicsEnum]
  // hazardSymbols: [HazardSymbolsEnum]
  // hazardStatements: [HazardStatementsEnum]
  // securityNotices: [SecurityNoticesEnum]
  // animalCategoriesForFeed: [AnimalCategoriesForFeedEnum]

  minTransportTemperature?: number;
  maxTransportTemperature?: number;

  bulkImportFile?: string;
}

export interface IProductInput {
  additionalImages?: string[];
  adminStatus?: string;
  alcoholPercentage?: number;
  BNR?: string;
  category?: string;
  // foodlaCategory: FoodlaCategoryInput
  classification?: string;
  descriptive_size?: string;
  descriptive_size_amount?: number;
  descriptive_size_amount_extra?: number[];
  // descriptive_size_unit: DescriptiveSizeUnit
  EAN: string;
  EAN2?: string;
  image_src?: string;
  ingredient_statement?: string;
  latitude?: number;
  location?: string;
  longitude?: number;

  energi_kj?: number;
  energi_kcal?: number;
  fett?: number;
  mattatFett?: number;
  enkelomattatFett?: number;
  flerromattatFett?: number;
  kolhydrat?: number;
  sockerarter?: number;
  polyoler?: number;
  starkelse?: number;
  fiber?: number;
  protein?: number;
  salt?: number;
  // nutritional_unit: NutritionalUnit
  gross_weight_num?: number;
  gross_height?: number;
  gross_width?: number;
  gross_depth?: number;

  vitaminA?: number;
  vitaminD?: number;
  vitaminE?: number;
  vitaminK?: number;
  vitaminC?: number;
  tiamin?: number;
  riboflavin?: number;
  niacin?: number;
  vitaminB6?: number;
  folsyra?: number;
  vitaminB12?: number;
  biotin?: number;
  pantotensyra?: number;
  kalium?: number;
  klorid?: number;
  kalcium?: number;
  fosfor?: number;
  magnesium?: number;
  jarn?: number;
  zink?: number;
  koppar?: number;
  mangan?: number;
  fluorid?: number;
  selen?: number;
  krom?: number;
  molybden?: number;
  jod?: number;

  place_of_item_activity?: string;
  additional_required_information?: string;
  quantity_in_stock?: number;
  inactive?: boolean;
  pricing?: string;
  short_text?: string;
  title: string;
  trade_item_temperature_information?: string;
  unit?: string;
  video?: string;
  consumer_size_to_order_size_ratio?: number;
  // approve: [ApproveInput]
  // labels: [LabelInput]

  color?: string;
  non_food_ingredients?: string;
  material?: string;
  dimensions?: string;
  capacity?: string;
  package_size?: number;
  package_size_unit?: string;
  country_of_manufacturing?: number;
  brand?: string;
  brand_food?: string;

  min_temperature?: number;
  max_temperature?: number;
  search_terms?: string;
  imageUnderProcess?: boolean;
  ignoreEANLengthError?: boolean;

  price?: number;
  priceEAN?: string;
  issueActiveDate?: number;
  lastreturndate?: number;
  totalNumberIssues?: number;
  currentIssueNumber?: number;
  currentIssueYear?: number;
  isMagazine?: boolean;
  alternativeTitle?: string;

  // Basic Data
  basicDataMixCategory?: boolean;
  basicDataTradeItemVariableUnit?: boolean;
  basicDataTaxClassification?: number;

  basicDataPriceComparisonContentType?: string;

  basicDataAvailabilityDateFrom?: number;
  articleFirstOrderDate?: number;
  articleFirstDelivery?: number;

  basicDataCbuIndicator?: boolean;

  // Konsumentförpackning / Consumer pack
  consumerPackOrderableUnit?: boolean;
  consumerPackDespatchUnit?: boolean;
  consumerPackNetWeight?: number;

  // Butiksförpackning / Store pack
  storePackEANForStorePack?: string;
  storePackOrderableUnit?: boolean;
  storePackDespatchUnit?: boolean;
  storePackTradeItemMeasurementsLengthDepth?: number;
  storePackTradeItemMeasurementsWidth?: number;
  storePackTradeItemMeasurementsHeight?: number;
  storePackGrossWeight?: number;

  // Transportförpackning / Transport Pack
  transportEANForStorePack?: string;
  transportQtyOfBaseItem?: number;
  transportQtyOfNextLowerItem?: number;
  transportOrderableUnit?: boolean;
  transportDespatchUnit?: boolean;
  transportTradeItemMeasurementsLengthDepth?: number;
  transportTradeItemMeasurementsWidth?: number;
  transportTradeItemMeasurementsHeight?: number;
  transportGrossWeight?: number;
  transportMinTemperature?: number;
  transportMaxTemperature?: number;

  // Pall/Pallet Layer
  palletLayerEANForStorePack?: string;
  palletLayerQtyOfBaseItem?: number;
  palletLayerQtyOfNextLowerItem?: number;
  palletLayerOrderableUnit?: boolean;
  palletLayerDespatchUnit?: boolean;
  palletLayerTradeItemMeasurementsLengthDepth?: number;
  palletLayerTradeItemMeasurementsWidth?: number;
  palletLayerTradeItemMeasurementsHeight?: number;
  palletLayerGrossWeight?: number;

  // Pall/Pallet
  palletQtyOfStorePack?: number;
  palletEANForStorePack?: string;
  palletQtyOfBaseItem?: number;
  palletQtyOfNextLowerItem?: number;
  palletOrderableUnit?: boolean;
  palletDespatchUnit?: boolean;
  palletTradeItemMeasurementsLengthDepth?: number;
  palletTradeItemMeasurementsWidth?: number;
  palletTradeItemMeasurementsHeight?: number;
  palletGrossWeight?: number;
  lavQuantity?: number;

  // Price
  priceListPriceCurrency?: string;
  priceListPrice?: number;
  priceRecommendedConsumerPrice?: number;

  // Purchasing Data
  purchasingDataSupplierArticleNo?: string;
  purchasingDataIncoterm?: string;
  purchasingDataPickupLocation?: string;

  // Quality review
  qrLabelingSwedish?: boolean;
  qrMedicalClaims?: boolean;
  qrMarketingClaimsCosmetic?: boolean;
  qrEfsaUlValues?: boolean;
  qrNutritionClaims?: boolean;
  qrNutritionClaimsCode?: QrNutritionClaimsCode | null;
  qrHealthClaims?: boolean;
  qrHealthClaimsCode?: QrHealthClaimsCode | null;
  qrFoodLabeling?: boolean;
  qrMisleadingSalesTerms?: boolean;
  qrFoodHygiene?: boolean;
  qrClassificationLabelingPackaging?: boolean;
  qrElectronic?: boolean;
  qrElectronicCode?: QrElectronicCode | null;
  qrAdditivesInFeed?: boolean;
  qrFeedLabeling?: boolean;
  qrRelevantFeedCertifications?: boolean;

  // New string fields
  shortSalesDescription?: string;
  animalFoodIngredients?: string;
  eggPackerApprovalNumber?: string;
  dosageAndUsageInstructions?: string;
  preparationInstructions?: string;
  responsibleLabelingApprovalNumber?: string;
  feedAdditives?: string;
  analyticalConstituentsFeed?: string;
  feedingInstructions?: string;
  animalAgeGroup?: string;
  CMRSubstances?: string;
  informationHazardousSubstances?: string;
  specifyCEStandards?: string;
  explanationNoUDI?: string;
  regulatedSubstance?: string;

  // New boolean fields
  cmrSubstance?: boolean;
  reachSubstance?: boolean;
  bestBeforeDate?: boolean;
  childrenUnder16?: boolean;
  complianceEg12232009?: boolean;
  complianceReach19072006?: boolean;
  reachSubstancesAnnex19072006?: boolean;
  hazardousSubstancesOver1?: boolean;
  complianceProductSafety2004451?: boolean;
  ceMarking?: boolean;
  complianceMedicalTechProducts?: boolean;
  complianceHaccp?: boolean;
  plasticTrayPackaging?: boolean;
  compliancePpwrPackaging?: boolean;
  checkUniqueIdentification?: boolean;

  // New single select fields
  // fishProductionMethod: FishProductionMethodEnum
  // fishCatchMethod: FishCatchMethodEnum
  // catchArea: CatchAreaEnum
  // eggWeightClass: EggWeightClassEnum
  // recyclingType: RecyclingTypeEnum
  // signalWords: SignalWordsEnum
  // preparedForm: PreparedFormEnum
  // categoryWeightloss: CategoryWeightlossEnum
  // complianceBiocid: ComplianceBiocidEnum
  // complianceBiocidalTreated: ComplianceBiocidalTreatedEnum
  // confirmGuidanceSwedishElectronics: ConfirmGuidanceSwedishElectronicsEnum
  // complianceToyDirective: ComplianceToyDirectiveEnum
  // complianceMetalsSkinContact: ComplianceMetalsSkinContactEnum
  // approvalDietFeed: ApprovalDietFeedEnum
  // complianceSunscreenRegulation: ComplianceSunscreenRegulationEnum
  // sunProtectionFactor: SunProtectionFactorEnum

  // New multiple select fields
  // additionalCharacteristics: [AdditionalCharacteristicsEnum]
  // hazardSymbols: [HazardSymbolsEnum]
  // hazardStatements: [HazardStatementsEnum]
  // securityNotices: [SecurityNoticesEnum]
  // animalCategoriesForFeed: [AnimalCategoriesForFeedEnum]

  minTransportTemperature?: number;
  maxTransportTemperature?: number;

  bulkImportFile?: string;
}

export const syncCurrentApprove = ({
  approve,
  currentApprove,
}: {
  approve?: IApprove[] | null;
  currentApprove?: IApprove[] | null;
}): IApprove[] => {
  const safeApprove = approve || [];
  const safeCurrentApprove = currentApprove || [];
  const approveMap = new Map(safeApprove.map(item => [item.field, item.state]));

  const result = [
    ...safeCurrentApprove.map(item => {
      if (!approveMap.has(item.field)) return item;
      return { ...item, state: approveMap.get(item.field) };
    }),
    ...safeApprove.filter(item => !safeCurrentApprove.some(currentItem => currentItem.field === item.field)),
  ];

  return result.filter(item => !isNil(item.state));
};

export const restoreApprove = ({
  approve,
  currentApprove,
}: {
  approve?: IApprove[] | null;
  currentApprove?: IApprove[] | null;
}): IApprove[] => {
  const safeApprove = approve || [];
  const safeCurrentApprove = currentApprove || [];
  const currentApproveMap = new Map(safeCurrentApprove.map(item => [item.field, item.state]));

  return safeApprove.map(item => ({
    ...item,
    state: currentApproveMap.has(item.field) ? currentApproveMap.get(item.field) : item.state,
  }));
};
